// /ote-endorsement/:token — public download page for the client's MOM OTE endorsement (link in the endorsement email,
// valid 12 months). Always the LATEST issued endorsement of the job (a clerical re-issue replaces what it opens).
// The file is MOM's own Excel form (filled in by AuditPM), which the client uploads to MOM unchanged.
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { FirmHeader } from '../components/PublicComponents'

export default function OTEEndorsementDownload() {
  const { token } = useParams()
  const [info, setInfo] = useState(null)      // get_ote_link result
  const [busy, setBusy] = useState(false)
  const [msg, setMsg] = useState('')

  function check() {
    setMsg('')
    supabase.rpc('get_ote_link', { p_token: token }).then(({ data }) => setInfo(data || { status: 'invalid' }))
  }
  useEffect(check, [token])

  async function download() {
    setBusy(true); setMsg('')
    try {
      const { data } = await supabase.functions.invoke('ote-public', { body: { action: 'download', token } })
      if (data?.status === 'ready' && data.url) { window.location.href = data.url }
      else if (['preparing', 'error', 'expired', 'invalid'].includes(data?.status)) setInfo(i => ({ ...i, status: data.status }))
      else setMsg('Sorry, the endorsement could not be downloaded. Please try again.')
    } catch (e) { setMsg('Sorry, the endorsement could not be downloaded. Please try again.') }
    setBusy(false)
  }

  const box = (children) => (
    <div style={{ minHeight: '100vh', background: '#f7f6f3', padding: '40px 20px' }}>
      <div style={{ maxWidth: 520, margin: '0 auto' }}>
        <FirmHeader accredited={false} />
        <div style={{ background: '#fff', borderRadius: 12, padding: 32, border: '0.5px solid rgba(0,0,0,0.1)', textAlign: 'center' }}>{children}</div>
      </div>
    </div>
  )

  if (!info) return box(<div style={{ color: '#999' }}>Loading…</div>)
  if (info.status === 'invalid') return box(<><h2 style={{ fontWeight: 500 }}>Invalid link</h2><p style={{ color: '#666', fontSize: 14 }}>This link is not valid. Please reply to our email or call us at (65) 6376 0550.</p></>)
  if (info.status === 'expired') return box(<><h2 style={{ fontWeight: 500 }}>This link has expired</h2><p style={{ color: '#666', fontSize: 14, lineHeight: 1.6 }}>Download links are valid for 12 months. Please reply to our email and we will send you a new link.</p></>)
  const btn = { padding: '12px 28px', borderRadius: 8, border: 'none', background: '#006363', color: '#fff', fontWeight: 600, fontSize: 15, cursor: 'pointer', fontFamily: 'inherit' }
  const notReady = info.status === 'preparing' || info.status === 'error'
  return box(<>
    <div style={{ fontSize: 13, color: '#888', marginBottom: 6 }}>{info.company_name}</div>
    <h2 style={{ fontWeight: 500, marginBottom: 18 }}>Endorsement of Risk Register (Overtime Exemption)</h2>
    {notReady
      ? <>
          <p style={{ color: '#666', fontSize: 14, lineHeight: 1.6, margin: '0 0 16px' }}>Your endorsement is being prepared. Please check again in a minute, or reply to our email if you need it urgently.</p>
          <button onClick={check} style={btn}>Check again</button>
        </>
      : <>
          <button onClick={download} disabled={busy} style={btn}>{busy ? 'Preparing…' : 'Download endorsement (Excel)'}</button>
          <p style={{ color: '#666', fontSize: 13, lineHeight: 1.6, margin: '16px 0 0' }}>This is MOM’s own Excel form, completed and signed by our WSH auditor. Please upload this file to MOM as it is — do not copy it into another file or save it as PDF.</p>
        </>}
    {msg && <p style={{ color: '#8a5a00', fontSize: 13, marginTop: 14 }}>{msg}</p>}
    {info.expires_at && <p style={{ color: '#999', fontSize: 12, marginTop: 18 }}>This link is valid until {new Date(info.expires_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}.</p>}
  </>)
}
